<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g
                transform="translate(-520 -660) translate(496 123) translate(24 348) translate(0 188) translate(0 1)"
              >
                <rect width="10" height="8" x="3" y="6" fill="#6783B2" rx="2" />
                <rect width="2" height="2" x="7" y="9" fill="#FFF" rx="1" />
                <rect
                  width="5"
                  height="6"
                  x="5.5"
                  y="2.5"
                  stroke="#6783B2"
                  rx="2.5"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'LockIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
